const giftMessageConstants = {
  GIFT_MESSAGE_SAVE_STARTED: "GIFT_MESSAGE_SAVE_STARTED",
  GIFT_MESSAGE_SAVE_SUCCESS: "GIFT_MESSAGE_SAVE_SUCCESS",
  GIFT_MESSAGE_SAVE_FAILED: "GIFT_MESSAGE_SAVE_FAILED",
  GIFT_MESSAGE_REMOVE_STARTED: "GIFT_MESSAGE_REMOVE_STARTED",
  GIFT_MESSAGE_REMOVE_SUCCESS: "GIFT_MESSAGE_REMOVE_SUCCESS",
  GIFT_MESSAGE_REMOVE_FAILED: "GIFT_MESSAGE_REMOVE_FAILED",
  GIFT_MESSAGE_EDIT: "GIFT_MESSAGE_EDIT",
  GIFT_MESSAGE_CHAR_LIMIT: 200,
  GIFT_MESSAGE_REQUIRED_ERROR_RESET: "GIFT_MESSAGE_REQUIRED_ERROR_RESET",
}

export default giftMessageConstants
